import { render, staticRenderFns } from "./HomeContentOld.vue?vue&type=template&id=77feff23&scoped=true"
import script from "./HomeContentOld.vue?vue&type=script&lang=js"
export * from "./HomeContentOld.vue?vue&type=script&lang=js"
import style0 from "./HomeContentOld.vue?vue&type=style&index=0&id=77feff23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77feff23",
  null
  
)

export default component.exports